export const modalSelectStyle = {
  "& .MuiSelect-select": {
    fontSize: "16px",
    color: "#3B425A",
    backgroundColor: "#F6F6F6",
  },
  "& .MuiInputLabel-root": {
    fontSize: "16px",
    color: "#3B425A",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#2DB6A3",
  },
  "& .MuiInputLabel-shrink": {
    fontSize: "14px",
  },
};
